import { Injectable } from '@angular/core'
import { SidebarComponent } from './sidebar/sidebar.component'
import { BehaviorSubject } from 'rxjs'

export interface SidebarAction {
    unfoldable?: boolean | 'toggle'
    visible?: boolean | 'toggle'
    toggle?: 'visible' | 'unfoldable'
    narrow?: boolean
    mobile?: boolean
    sidebar?: SidebarComponent
    id?: string
}

@Injectable({
    providedIn: 'root',
})
export class SidebarService {
    private sidebarState = new BehaviorSubject<SidebarAction>({})
    sidebarState$ = this.sidebarState.asObservable()

    toggle(action: SidebarAction): void {
        this.sidebarState.next(action)
    }
}
